import { useLang } from '../../contexts/LangContext'

const steps = [
  { key: 'pending', el: 'Αίτημα', en: 'Requested' },
  { key: 'confirmed', el: 'Επιβεβαίωση', en: 'Confirmed' },
  { key: 'in_progress', el: 'Σε εξέλιξη', en: 'In progress' },
  { key: 'completed', el: 'Ολοκλήρωση', en: 'Completed' },
] as const

function stepState(
  key: string,
  status: string,
  confirmedAt: string | null,
  startedAt: string | null,
  completedAt: string | null,
) {
  if (key === 'pending') return status === 'pending' ? 'active' : 'done'
  if (key === 'confirmed') {
    if (status === 'confirmed') return 'active'
    return confirmedAt || ['in_progress', 'completed'].includes(status) ? 'done' : 'todo'
  }
  if (key === 'in_progress') {
    if (status === 'in_progress') return 'active'
    return startedAt || status === 'completed' ? 'done' : 'todo'
  }
  if (key === 'completed') {
    if (status === 'completed') return 'active'
    return completedAt ? 'done' : 'todo'
  }

  return 'todo'
}

export default function BookingStatusTimeline({
  status,
  confirmedAt,
  startedAt,
  completedAt,
}: {
  status: string
  confirmedAt: string | null
  startedAt: string | null
  completedAt: string | null
}) {
  const { locale, t } = useLang()
  const terminalState = status === 'cancelled' || status === 'declined'

  return (
    <div className="rounded-[1.5rem] border border-slate-200 bg-white p-5 shadow-sm">
      <div className="grid gap-4 md:grid-cols-4">
        {steps.map((step, index) => {
          const state = stepState(step.key, status, confirmedAt, startedAt, completedAt)

          return (
            <div key={step.key} className="flex items-center gap-3">
              <span
                className={[
                  'flex h-10 w-10 shrink-0 items-center justify-center rounded-full border text-sm font-bold',
                  state === 'done' && 'border-emerald-200 bg-emerald-50 text-emerald-700',
                  state === 'active' && 'border-primary-200 bg-primary-50 text-primary-700',
                  state === 'todo' && 'border-slate-200 bg-slate-50 text-slate-400',
                ].filter(Boolean).join(' ')}
              >
                {index + 1}
              </span>
              <div>
                <p className="text-sm font-semibold text-slate-950">{step[locale]}</p>
                <p className="text-xs text-slate-500">
                  {state === 'done' && t('Ολοκληρώθηκε', 'Completed')}
                  {state === 'active' && t('Τρέχον στάδιο', 'Current step')}
                  {state === 'todo' && t('Επόμενο στάδιο', 'Upcoming step')}
                </p>
              </div>
            </div>
          )
        })}
      </div>

      {terminalState && (
        <p className="mt-4 rounded-xl border border-rose-100 bg-rose-50 px-4 py-3 text-sm text-rose-700">
          {status === 'cancelled'
            ? t('Η κράτηση ακυρώθηκε πριν ολοκληρωθεί η κανονική ροή.', 'This booking was cancelled before completing the normal flow.')
            : t('Το αίτημα απορρίφθηκε από τον επαγγελματία.', 'This request was declined by the provider.')}
        </p>
      )}
    </div>
  )
}
